<template>
  <section class="p-5 container">
    <div class="title mb-5 container text-center title-hr">
      <h3>4大功能升级</h3>
    </div>
    <el-row :gutter="20">
      <el-col :span="12" v-for="(item, index) in v3List" v-bind:key="index">
        <div class="grid-content-v3-web bg-purple" :style="{ backgroundImage: 'url(' + item.backgroundImage + ')' }">
          <el-row>
            <el-col :span="2" class="text-center">
              <div class="num">{{ item.num }}</div>
            </el-col>
            <el-col :span="22">
              <p class="text-333 title">{{ item.title }}</p>
              <el-row v-for="(group, index1) in item.desc" v-bind:key="index1">
                <el-col :span="1" class="text-center">
                  <i class="iconfont iconfangkuai text-1e6ce8"></i>
                </el-col>
                <el-col :span="22">
                  <p class="text-333 mb-2" v-html="group.sub"></p>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <div class="">
      <div class="title mb-5 container text-center title-hr">
        <h3>巧记账价格表</h3>
        <h4 class="text-1e6ce8">Price list</h4>
      </div>
      <div class="JQweb-price">
        <div class="tabs">
          <div class="tab" :class="{ active: activeTab === 'small' }" @click="activeTab = 'small'">小规模纳税人</div>
          <div class="tab" :class="{ active: activeTab === 'general' }" @click="activeTab = 'general'">一般纳税人</div>
        </div>
        <div class="tab-content" v-if="activeTab === 'small'">
          <div class="tab-item" v-for="(item, index) in v3priceList[0].prolist" :key="`small-${index}`" :class="item.active?'active' :'' " @click="selectTab(index)">
            <h3>{{ item.title }}</h3>
            <h2 class="sub-text"><span class="font-18">¥</span>{{ item.sub }}</h2>
            <div class="third-month">{{ item.third }}</div>
            <div class="ul">
              <p class="li" v-for="(group, index2) in item.list" :key="`general-list-${index2}`">·{{ group.text }}</p>
            </div>
            <div class="button"  @click="goButton(index)">立即开通</div>
            <div class="tag" v-if="index==0">限时限量</div>
          </div>
        </div>
        <div class="tab-content" v-if="activeTab === 'general'">
          <div class="tab-item" v-for="(item, index) in v3priceList[1].prolist" :key="`general-${index}`" :class="item.active?'active' :'' " @click="selectTab2(index)">
            <h3>{{ item.title }}</h3>
            <h2 class="sub-text"><span class="font-18">¥</span>{{ item.sub }}</h2>
            <div class="third-month">{{ item.third }}</div>
            <div class="ul">
              <p class="li" v-for="(group, index2) in item.list" :key="`general-list-${index2}`">·{{ group.text }}</p>
            </div>
            <div class="button" @click="goButton(index)">立即开通</div>
            <div class="tag" v-if="index==0">限时限量</div>
          </div>
        </div>
        <div class="first-content">
          <div class="left">
            <div class="left-time">限时限量</div>
            <!-- <div class="left-come">立即开通>></div> -->
          </div>
          <div class="right"><span class="h4">首月尝鲜体验<span class="first-price h2">0.1</span>元/首月</span><span class="red">(仅限新客)</span></div>
          <div class="button" @click="goButton(1)">立即开通</div>

        </div>
        <div class="tab-list"><div class="tab-li" :class="{ active: activeTab === 'small' }"  @click="activeTab = 'small'"></div><div class="tab-li" :class="{ active: activeTab === 'general' }" @click="activeTab = 'general'"></div></div>
      </div>
      <div class="dialog" v-show="showDialog"  @click="closeDialog">
        <el-image :src="dialogImg" fit="fill" class="dialog-image" ></el-image>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Lowprice',
  props: { bg: String },
  data () {
    return {
      v3List: [
        {
          num: 1,
          title: '自动抓取票据,智能归类生成凭证',
          backgroundImage: require('../../../assets/image/web-v3-01.png'),
          desc: [
            {
              sub: '无需上传收入发票汇总表',
            },
            {
              sub: '无需上传费用发票,无需勾选费用类别',
            },
            {
              sub: '自动抓取社保缴费单及缴税凭证',
            },
            {
              sub: '自动抓取银行签约对账单及回单',
            },
            {
              sub: '仅作确认即可',
            },
          ],
        },
        {
          num: 2,
          title: '支持零申报企业一键托管',
          backgroundImage: require('../../../assets/image/web-v3-02.png'),
          desc: [
            {
              sub: '勾选零申报托管',
            },
            {
              sub: '全程自动申报',
            },
            {
              sub: '无需确认',
            },
          ],
        },
        {
          num: 3,
          title: '权委托服务模式支持',
          backgroundImage: require('../../../assets/image/web-v3-03.png'),
          desc: [
            {
              sub: '记账、开票、人事、企银直连、<br>零星服务全托',
            },
            {
              sub: '自动完成一般纳税人进项认证',
            },
          ],
        },
        {
          num: 4,
          title: '虚拟CFO小巧提供咨询支持',
          backgroundImage: require('../../../assets/image/web-v3-04.png'),
          desc: [
            {
              sub: '专属群添置CFO智能服务'
            },
            {
              sub: '提供报表分析、预算成本控制等<br>财务咨询解答',
            },
          ],
        },
      ],
      dialogImg: require('../../../assets/image/img-v3-dialog.png'),
      hotImg: require('../../../assets/image/img-hot.png'),
      activeTab: 'small',
      active: '0',
      showDialog: false,
      v3priceList: [{
        name: '小规模纳税人',
        prolist: [
          {
            title: '3年智能记账',
            sub: '3192',
            third: '72元/月',
            hot: true,
            active: true,
            list: [
              { text: '自动接账建账' },
              { text: 'AI制单记账/人工审核' },
              { text: '确认式AI报税' },
              { text: '自助工资个税申报' },
              { text: '老板报表数据看板模块' },
              { text: '专属售后群+AI小巧' },
              { text: 'VIP售后优先权' },
              { text: '年报公示服务(300元/次)' },
              { text: '汇算清缴服务(300元/次)' },
              { text: '零申报托管模块' },
              { text: '获得创业工具包' },
              { text: '上海公司注册免费(不限次)' },
              { text: '免费迁址+变更+返税' },
              { text: '企业家私享会VIP席位' },
              { text: '减资服务' },
              { text: '享受全场通用保障' }
            ]
          },
          {
            title: '2年智能记账',
            sub: '3192',
            third: '108元/月',
            hot: false,
            active: false,
            list: [
              { text: '自动接账建账' },
              { text: 'AI制单记账/人工审核' },
              { text: '确认式AI报税' },
              { text: '自助工资个税申报' },
              { text: '老板报表数据看板模块' },
              { text: '专属售后群+AI小巧' },
              { text: '年报公示服务(300元/次)' },
              { text: '汇算清缴服务(300元/次)' },
              { text: '零申报托管模块' },
              { text: '获得创业工具包' },
              { text: '上海公司注册免费(不限次)' },
              { text: '免费迁址+变更+返税' },
              { text: '企业家私享会VIP席位' },
              { text: '减资服务' },
              { text: '享受全场通用保障' }
            ]
          },
          {
            title: '1年智能记账',
            sub: '1596',
            third: '108元/月',
            hot: false,
            active: false,
            list: [
              { text: '自动接账建账' },
              { text: 'AI制单记账/人工审核' },
              { text: '确认式AI报税' },
              { text: '自助工资个税申报' },
              { text: '老板报表数据看板模块' },
              { text: '专属售后群+AI小巧' },
              { text: '年报公示服务(300元/次)' },
              { text: '汇算清缴服务(300元/次)' },
              { text: '零申报托管模块' }
            ]
          }
        ]
      },
      {
        name: '一般纳税人',
        prolist: [
          {
            title: '3年智能记账',
            sub: '5832',
            third: '145元/月',
            hot: true,
            active: true,
            list: [
              { text: '自动接账建账' },
              { text: 'AI制单记账/人工审核' },
              { text: '确认式AI报税' },
              { text: '自助工资个税申报' },
              { text: '老板报表数据看板模块' },
              { text: '专属售后群+AI小巧' },
              { text: 'VIP售后优先权' },
              { text: '年报公示服务(300元/次)' },
              { text: '汇算清缴服务(300元/次)' },
              { text: '零申报托管模块' },
              { text: '获得创业工具包' },
              { text: '上海公司注册免费(不限次)' },
              { text: '免费迁址+变更+返税' },
              { text: '企业家私享会VIP席位' },
              { text: '减资服务' },
              { text: '享受全场通用保障' }
            ]
          },
          {
            title: '2年智能记账',
            sub: '5832',
            third: '218元/月',
            hot: false,
            active: false,
            list: [
              { text: '自动接账建账' },
              { text: 'AI制单记账/人工审核' },
              { text: '确认式AI报税' },
              { text: '自助工资个税申报' },
              { text: '老板报表数据看板模块' },
              { text: '专属售后群+AI小巧' },
              { text: '年报公示服务(300元/次)' },
              { text: '汇算清缴服务(300元/次)' },
              { text: '零申报托管模块' },
              { text: '获得创业工具包' },
              { text: '上海公司注册免费(不限次)' },
              { text: '免费迁址+变更+返税' },
              { text: '企业家私享会VIP席位' },
              { text: '减资服务' },
              { text: '享受全场通用保障' }
            ]
          },
          {
            title: '1年智能记账',
            sub: '2916',
            third: '218元/月',
            hot: false,
            active: false,
            list: [
              { text: '自动接账建账' },
              { text: 'AI制单记账/人工审核' },
              { text: '确认式AI报税' },
              { text: '自助工资个税申报' },
              { text: '老板报表数据看板模块' },
              { text: '专属售后群+AI小巧' },
              { text: '年报公示服务(300元/次)' },
              { text: '汇算清缴服务(300元/次)' },
              { text: '零申报托管模块' }
            ]
          }
        ]
      }]
    }
  },
  mounted () { },
  methods: {
    selectTab: function (index) {
      console.log(index, 'index')
      this.v3priceList[0].prolist.forEach((item, i) => {
        item.active = i === index
      })
      console.log(this.v3priceList[0].prolist, 'this.v3priceList[0].prolist')
    },
    selectTab2: function (index) {
      console.log(index, 'index')
      this.v3priceList[1].prolist.forEach((item, i) => {
        item.active = i === index
      })
    },
    goButton: function (index) {
      if (index === 0) {
        this.showDialog = true
        console.log(this.showDialog,   '11111')
      } else {
        // window.open('http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn')
        this.$alert('业务咨询：021-5450-5858 17721220254\n商务合作：021-64670039\n智能代账更多福利，请微信搜索“巧记账”视频号，添加客服领取')
      loadingInstance.close()
      }
    },
    closeDialog() {
      this.showDialog = false;
    }

  }
};
</script>
<style>
.el-tabs__nav-wrap::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0 !important;
  background-color: #fff !important;
  z-index: 1;
}

.el-tabs__nav {
  text-align: center !important;
  float: none !important;
}

.el-tabs__active-bar {
  display: none !important;
}

.el-tabs__item {
  margin: 0 20px !important;
  padding: 0 !important;
  height: 40px !important;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 40px !important;
  display: inline-block;
  list-style: none !important;
  font-size: 14px !important;
  font-weight: 500;
  border: 1px solid #0044ff;
  color: #0044ff !important;
  position: relative;
  text-align: center;
  background: none;
  width: 140px !important;
}

.el-tabs__item.is-active {
  color: #fff !important;
  background: #0044ff !important;
}

.el-card__body {
  padding: 0px !important;
}

.tax-top-title {
  padding: 20px 30px;
  background: #0044ff;
  color: #fff;
  position: relative;
}

.tax-top-title .img-tuijian {
  position: absolute;
  top: 0;
  right: 0;
  width: 60px;
  height: 60px;
}

.tax-box-item {
  background: #d3e0ff;
  padding: 20px 30px;
  position: relative;
}

.tax-bottom {
  padding: 20px 30px 30px;
  position: relative;
}

.tax-bottom i.iconsanjiaodown {
  position: absolute;
  left: 50%;
  top: -10px;
  color: #d3e0ff;
}

.tax-ul,
li {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.tax-ul {
  height: 360px;
}

.tax-ul li {
  line-height: 2;
}

.tax-button {
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  font-size: 14px;
  display: block;
  width: 100%;
  background: #0044ff;
  border-radius: 20px;
  padding: 12px 23px;
  color: #fff;
}

.tax-button:hover,
.tax-button:active {
  color: #f5f5f5;
  background: #013ee4;
  text-decoration: none;
}

/*四大新功能*/
.grid-content-v3-web {
  height: 300px;
  background-size: 100%;
  background-repeat: no-repeat;
  padding: 35px 50px;
}

.grid-content-v3-web .num {
  width: 24px;
  height: 24px;
  text-align: center;
  background: #013ee4;
  color: #fff;
  border-radius: 5px;
  border-bottom-right-radius: 0;
  border: 1px solid #a7e8f8;
  line-height: 24px;
}

.grid-content-v3-web .title {
  font-weight: 600;
}

.grid-content-v3-web .desc {
  font-weight: 600;
}

.serives {
  background: #013ee4;
  border-radius: 10px;
  padding: 30px;
}

.serives .item {
  background: #fff;
  margin-bottom: 30px;
  border-radius: 10px;
  padding: 20px;
}

.serives .title {
  font-size: 24px;
  color: #333;
  font-weight: 600;
  margin-top: 10px;
}

.serives .title .sub {
  font-size: 18px;
  color: #013ee4;
  font-weight: 400;
}

.serives .third {
  font-size: 18px;
  color: #999;
  margin-top: 15px;
}

.serives .price {
  font-size: 32px;
  color: rgb(248, 101, 2);
  font-weight: 700;
  margin-top: 10px;
}

.serives .btn-custom {
  display: inline-block;
  text-align: center;
  padding: 8px 10px;
  border-radius: 20px;
  background-image: linear-gradient(to right, #c436fc, #013ee4);
  transition: background-image 0.3s ease;
  color: #fff;
  font-size: 16px;
  margin-left: 20px;
}

/*v3价格*/

.tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.tab {
  padding: 8px 30px;
  cursor: pointer;
  border: 1px solid #0044ff;
  border-radius: 25px;
  margin: 0 10px;
}

.tab.active {
  border-bottom: none;
  font-weight: bold;
  background-color: #0044ff;
  color: #fff;
}

.tab-content {
  margin-top: 40px;
  display: flex;
  justify-content: space-between; /* This will add space between the columns */
}

.tab-item {
  flex: 1; /* Each item will take up equal space */
  margin: 0 35px; /* Add margin for spacing between items */
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding:50px 20px 60px;
  position: relative;
  overflow: hidden;

}
.tab-item::after {
  content: "";
  position: absolute;
  top: -15%;
  left:-20%;
  width: 130%;
  height: 50%;
  background-color:#f6f6f6;
  border-bottom-left-radius:25%;
  border-bottom-right-radius:80%;
  z-index: -1;
}
.tab-item.active{
  border: 1px solid #0044ff;
  /* background:#ebeffa; */
  background-color: rgba(235, 239, 250, 0.5);

}
.tab-item.active::after {
  content: "";
  position: absolute;
  top: -15%;
  left:-20%;
  width: 130%;
  height: 50%;
  background-color:#dfe9ff;
  border-bottom-left-radius:25%;
  border-bottom-right-radius:80%;
  z-index: -1;
}
/* If you want the first and last item to align with the edges of the container */
.tab-content .tab-item:first-child,
.tab-content .tab-item:last-child {
  margin-left: 0;
  margin-right: 0;
}
.tab-item  .sub-text{
  color: #0044ff;
}
.tab-item  .third-month{
  color: #0044ff;
  border: 1px solid #0044ff;
  font-size: 14px;
  border-radius: 20px;
  padding: 6px 30px;
  display: inline-block;
}

.tab-item .ul {
  margin: 20px auto;
}
.tab-item .ul .li{
 font-size: 14px;
 margin-bottom: 5px;
}
.tab-item .button{
  color: #0044ff;
  border: 1px solid #0044ff;
  border-radius: 20px;
  width: 120px;
  height: 38px;
  display: inline-block;
  position: absolute;
  bottom: 25px;
  left: 50%;
  margin-left: -60px;
  line-height: 36px;
  cursor: pointer;
  z-index: 4;
}
.tab-item.active .button{
  background: #0044ff;
  color: #fff;
  cursor: pointer;

}
.tab-item .tag{
  background: #0044ff;
  width: 80px;
  height: 35px;
  line-height: 35px;
  color: #ffffff;
  font-size: 14px;
  position:absolute;
  top:0;
  left:0;
  border-top-left-radius:8px;
  border-bottom-right-radius:8px;
}
.tab-item .tag::after{
  content: "";
  position: absolute;
  top: 0;
  right: -16px;
  border-top: 33px solid #0044ff;
  border-bottom: 18px solid transparent;
  border-right: 18px solid transparent;

}
.tab-list{
  margin:60px auto 0;
  text-align: center
}
.tab-list .tab-li{
  width: 60px ;
  height:4px;
  background: #e7e7e7;
  display: inline-block;
  margin: 10px;
}
.tab-list .tab-li.active{
  background: #0044ff;
}
.first-content{
  width: 100%;
  height: 50px;
  border: 1px solid #0044ff;
  display: flex;
  border-radius: 10px;
  margin: 30px auto;
}
.first-content .left{
  background: #0044ff;
  width: 140px;
  border-top-left-radius:8px;
  border-bottom-left-radius:8px;
  color: #fff;
  text-align: center;
  font-size:18px;
  line-height: 48px;
  position: relative;
}
.first-content .left::after{
  content: "";
  position: absolute;
  top: 0;
  right: -28px;
  border-top: 49px solid #0044ff;
  border-bottom: 28px solid transparent;
  border-right: 28px solid transparent;
}
.first-content .left .left-time{
 font-weight: 600;
}
.first-content .left .left-come{
 font-size: 14px;
}
.first-content .right{
  flex: 1;
  text-align: left;
  text-indent: 100px;
  font-size: 18px;
  line-height: 48px;
}
.first-content .right .first-price{
  padding: 0 10px;
  color: #0044ff;
}
.first-content .right .red{
  padding: 0 10px;
  color: #0044ff;
}
.first-content .button{
  color: #0044ff;
  border: 1px solid #0044ff;
  border-radius: 20px;
  width: 120px;
  height: 38px;
  /* display: inline-block; */
  text-align: center;
  /* position: absolute;
  bottom: 25px;
  left: 50%;
  margin-left: -60px; */
  line-height: 36px;
  margin-top: 5px;
  margin-right:100px;
  cursor: pointer;
}
.dialog{
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.2);
}
.dialog .dialog-image{
  width: 322px;
  height: 455px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Lowprice.vue